import * as React from 'react';
import { toast } from 'sonner';
import { copyToClipboard } from '../../../models/UiUtils';

export const useCopyToClipboard = () => {
	const handleCopy =
		(
			customUrl?: string,
			message?: {
				error?: string;
				success?: string;
			}
		) =>
		(event: React.MouseEvent<HTMLSpanElement>) => {
			event.stopPropagation();
			const { hash, origin, pathname } = location;
			const url = customUrl || `${origin + pathname}${hash}`;
			if (copyToClipboard(url)) {
				toast.success(message?.success || 'Copied to clipboard');
			} else {
				toast.error(message?.error || 'Failed to copy to clipboard');
			}
		};
	return handleCopy;
};
